const getters = {
    event: (state) => state.event,
    eventid: (state) => state.eventid,
    loading: state => state.loading
};

export default getters;